import { makeStyles } from '@material-ui/core/styles'
import { content } from '~/themes/colors'

export const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',

		'& input': {
			...theme?.typography?.body1,
			color: content.veryDark,
			marginBottom: 8,
		},

		'& input::placeholder': {
			color: content.dark,
			opacity: 1,
			textOverflow: 'ellipsis !important',
		},
	},

	adorment: {
		marginBottom: 9,
	},
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
	input: {
		'&::placeholder': {
			textOverflow: 'ellipsis !important',
		},
	},
}))
